import { Observable } from 'rxjs';
import { DetailsInterface } from '../models/details.model';
import { ReservationDetailsRequest } from '../usecases/getDetails.usecase';

export abstract class DetailsRepository {
    abstract getDetails(
        reservationDetails: ReservationDetailsRequest,
    ): Observable<DetailsInterface>;
}
